const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // like '/berry-material-react/react/default'
  // basename: '/free',
  // defaultPath: '/dashboard/default',
  basename: "/",
  defaultPath: "/",
  fontFamily: "'Poppins', sans-serif",
  borderRadius: 6
};

export const runTimeConfig = {
  CHATWITHDOCS_BASE_URL: window.__RUNTIME_CONFIG__.CHATWITHDOCS_BASE_URL as string,
  VITE_GA_TRACKING_CODE: window.__RUNTIME_CONFIG__.VITE_GA_TRACKING_CODE,
  VITE_BASE_URL: window.__RUNTIME_CONFIG__.VITE_BASE_URL,
  CHATWITHDOCS_BASIC_AUTH_CLIENTID: window.__RUNTIME_CONFIG__.CHATWITHDOCS_BASIC_AUTH_CLIENTID,
  CHATWITHDOCS_BASIC_AUTH_CLIENTSECRET:
    window.__RUNTIME_CONFIG__.CHATWITHDOCS_BASIC_AUTH_CLIENTSECRET,
  CHATWITHDOCS_PROJECTID: window.__RUNTIME_CONFIG__.CHATWITHDOCS_PROJECTID,
  ENABLE_AMWISE: window.__RUNTIME_CONFIG__.ENABLE_AMWISE,
  VITE_TICKET_GENERATOR_AI_CHAT_BASE_URL:
    window.__RUNTIME_CONFIG__.VITE_TICKET_GENERATOR_AI_CHAT_BASE_URL,
  VITE_TICKET_GENERATOR_AI_CHAT_API_KEY:
    window.__RUNTIME_CONFIG__.VITE_TICKET_GENERATOR_AI_CHAT_API_KEY
};

export default config;
